@let tabsList = tabsSg();
@let selectedTab = selectedTabSg();
@let selectedIndex = selectedIndexSg();
@let disabled = disabledSg();

<div class="ds-widget-side-tab">
  <div class="ds-widget-side-tab__headers">
    @for (tab of tabsList; track $index) {
      <div
        class="ds-widget-side-tab__header"
        [class.ds-widget-side-tab__header--selected]="selectedTab === tab"
        (click)="
          !(disabled || tab.disabledSg()) &&
            selectedIndex !== $index &&
            onTabClickHandler($index)
        "
      >
        {{ tab.nameSg() }}
      </div>
    }
  </div>
  <div class="ds-widget-side-tab__content">
    @if (selectedTab) {
      <ng-container>
        <ng-container
          *ngTemplateOutlet="selectedTab?.template ?? null"
        ></ng-container>
      </ng-container>
    }
  </div>
</div>
